<template>
    <div v-if="modal">
        <ul class="nav nav-tabs" id="myTab" role="tablist">
            <div :class=" modal.isPhisical ? 'col-xl-3 col-lg-3 col-md-3 col-sm-3 col-3' : 'col-xl-4 col-lg-4 col-md-4 col-sm-4 col-4'">
                <li class="nav-item" role="presentation">
                    <a class="nav-link" :class="{ active: modal.activeTab == 0 }"
                       @click="modal.activeTab = 0" id="tab-one-tab"
                       data-toggle="tab" href="#tab-one" role="tab" aria-controls="tab-one"
                       aria-disabled="true">{{ modal.isPhisical ? t('GENERAL.PERSONAL_DATA') : 'Dados da Empresa' }}</a>
                </li>
            </div>
            <div :class=" modal.isPhisical ? 'col-xl-3 col-lg-3 col-md-3 col-sm-3 col-3' : 'col-xl-4 col-lg-4 col-md-4 col-sm-4 col-4'">
                <li class="nav-item" role="presentation">
                    <a class="nav-link"
                       :class="{ active: modal.activeTab == 1, 'required': modal.isRequiredClassValidation('address_id')}"
                       @click.stop.prevent="modal.validateSecondAbaClick"
                       id="localization-tab" data-toggle="tab" href="#localization" role="tab"
                       aria-controls="localization"
                       aria-disabled="true">{{ t('CLIENTS.ADDRESS') }} </a>
                </li>
            </div>
            <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-3" v-if="modal.isPhisical">
                <li class="nav-item" role="presentation">
                    <a class="nav-link"
                       :class="{ active: modal.activeTab == 2, 'required': modal.isRequiredClassValidation('comercial_address_id')}"
                       @click.stop.prevent="modal.validateThirdAbaClick"
                       id="addresscompany-tab"
                       data-toggle="tab"
                       href="#addressCompany"
                       role="tab"
                       aria-controls="addressCompany"
                       aria-disabled="true">{{ t('CLIENTS.ADDRESS_COMPANY') }} </a>
                </li>
            </div>
            <div :class="modal.isPhisical ? 'col-xl-3 col-lg-3 col-md-3 col-sm-3 col-3' : 'col-xl-4 col-lg-4 col-md-4 col-sm-4 col-4'">
                <li class="nav-item" role="presentation">
                    <a class="nav-link" :class="{ active: modal.activeTab == 3 }"
                       @click.stop.prevent="modal.validateAnexAbaClick"
                       id="document-tab" data-toggle="tab" href="#document" role="tab" aria-controls="document"
                       aria-disabled="true">{{ t('CLIENTS.DOCUMENT') }}</a>
                </li>
            </div>
        </ul>
        <form @submit.prevent="modal.create">
            <div class="tab-content modal-row2 modal-height-max" id="myTabContent" v-if="modal.client"
                 style="overflow-x: hidden">
                <div class="tab-pane fade" :class="{ active: modal.activeTab == 0, show: modal.activeTab == 0 }"
                     id="tab-one"
                     role="tabpanel" aria-labelledby="allotment-tab">
                    <div class="modal-body pl-0 pr-0">
                        <div class="row gutters">
                            <div class="col-12">
                                <SectionCardComponent
                                        eyebrow="Dados principais"
                                        :title="modal.isPhisical ? 'Informações pessoais do cliente' : 'Informações cadastrais da empresa'"
                                        icon="icon-person">
                                    <template #subtitle>
                                        {{
                                            modal.isPhisical ? 'Informe identificação, dados civis, profissionais e contato; campos obrigatórios são marcados com' : 'Informe CNPJ, dados da empresa, contato e loteamento; campos obrigatórios são marcados com'
                                        }}
                                        <span class="client-main-panel__required-mark">*</span>.
                                    </template>
                                    <div class="row gutters">
                                        <div class="col-xl-3 col-lg-6 col-md-6 col-sm-6 col-6" v-if="modal.isPhisical">
                                            <div class="form-group">
                                                <label data-cy="client_add_taxpayer" for="taxpayer"
                                                       :class="{'required': modal.isRequiredClassValidation('taxpayer')}"
                                                >CPF: </label>
                                                <input type="text" id="taxpayer" name="taxpayer"
                                                       v-model="modal.client.taxpayer"
                                                       class="form-control"
                                                       inputmode="numeric"
                                                       onpaste="return false"
                                                       @change="modal.findClient(modal.client.taxpayer)"
                                                       placeholder="000.000.000-00"
                                                       ondrop="return false"
                                                       v-mask="['###.###.###-##']"
                                                       @keyup="modal.validateTaxpayer(modal.client.taxpayer)">
                                                <div v-if="modal.invalid.taxpayer" class="validation">
                                                    {{ t(modal.invalid.taxpayer) }}
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6" v-if="!modal.isPhisical">
                                            <div class="form-group">
                                                <label data-cy="client_add_taxpayer" for="taxpayer"
                                                       :class="{'required': modal.isRequiredClassValidation('taxpayer')}"
                                                >CNPJ:</label>
                                                <input type="text" id="taxpayer" name="taxpayer"
                                                       v-model="modal.client.taxpayer"
                                                       class="form-control"
                                                       onpaste="return false"
                                                       @change="modal.findClient(modal.client.taxpayer)"
                                                       @input="modal.client.taxpayer = modal.client.taxpayer?.toUpperCase()"
                                                       placeholder="00.000.000/0000-00"
                                                       ondrop="return false"
                                                       v-mask="['XX.XXX.XXX/XXXX-##']"
                                                       @keyup="modal.validateTaxpayer(modal.client.taxpayer)">
                                                <div v-if="modal.invalid.taxpayer" class="validation">
                                                    {{ t(modal.invalid.taxpayer) }}
                                                </div>
                                            </div>
                                        </div>
                                        <div v-if="modal.isPhisical" class="col-xl-3 col-lg-6 col-md-6 col-sm-6 col-6">
                                            <div class="form-group">
                                                <label :class="{'required': modal.isRequiredClassValidation('birthday')}"
                                                       v-if="modal.isPhisical"
                                                       for="birthday"
                                                >{{ t('CLIENTS.BIRTHDAY') }}: </label>
                                                <input data-cy="client_add_birthday"
                                                       type="text"
                                                       id="birthday"
                                                       name="birthday"
                                                       v-model="modal.client.birthday"
                                                       placeholder="dd-mm-aaaa"
                                                       v-mask="['##-##-####']"
                                                       class="form-control"
                                                       @change="modal.validateDate('birthday')"
                                                >
                                                <div v-if="modal.invalid.birthday" class="validation">{{
                                                        modal.invalid.birthday
                                                    }}
                                                </div>
                                            </div>
                                        </div>
                                        <div v-else class="col-xl-3 col-lg-6 col-md-6 col-sm-6 col-6">
                                            <div class="form-group">
                                                <label for="birthday"
                                                       :class="{'required': modal.isRequiredClassValidation('birthday')}"
                                                >{{ t('CLIENTS.FOUNDATION_DAY') }}: </label>
                                                <input data-cy="client_add_foundation_day" type="text" id="birthday"
                                                       name="foundationDay"
                                                       placeholder="dd-mm-aaaa"
                                                       v-model="modal.client.birthday"
                                                       class="form-control"
                                                       v-mask="['##-##-####']"
                                                       @change="modal.validateDate('birthday')"
                                                >
                                                <div v-if="modal.invalid.birthday" class="validation">{{
                                                        modal.invalid.birthday
                                                    }}
                                                </div>
                                            </div>
                                        </div>
                                        <div v-if="!modal.isPhisical"
                                             class="col-xl-3 col-lg-6 col-md-12 col-sm-12 col-12">
                                            <div class="form-group">
                                                <label :class="{'required': modal.isRequiredClassValidation('creci')}">{{
                                                        t('CLIENTS.CRECI')
                                                    }}: </label>
                                                <input type="text" id="creci" name="creci"
                                                       v-model="modal.client.creci" placeholder="Creci"
                                                       class="form-control">
                                                <div v-if="modal.invalid.creci" class="validation">
                                                    {{ modal.invalid.creci }}
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12" v-if="modal.isPhisical">
                                            <div class="form-group">
                                                <label for="name" class="required">{{ t('GENERAL.NAME') }}: </label>
                                                <input data-cy="client_add_name" type="text" id="name" name="name"
                                                       v-model="modal.client.name"
                                                       maxlength="60"
                                                       autocomplete="name"
                                                       class="form-control"
                                                       placeholder="Nome Completo">
                                                <div v-if="modal.invalid.name" class="validation">{{
                                                        modal.invalid.name
                                                    }}
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12"
                                             v-if="!modal.isPhisical">
                                            <div class="form-group">
                                                <label for="name"
                                                       class="required"
                                                >{{ t('COMPANIES.NAME') }}: </label>
                                                <input type="text" id="corporate_name" name="name"
                                                       maxlength="60"
                                                       autocomplete="name"
                                                       v-model="modal.client.corporate_name"
                                                       class="form-control">
                                                <div v-if="modal.invalid.name" class="validation">{{
                                                        modal.invalid.name
                                                    }}
                                                </div>
                                            </div>
                                        </div>
                                        <div v-if="modal.isPhisical" class="col-xl-2 col-lg-3 col-md-6 col-sm-6 col-6">
                                            <div class="form-group">
                                                <label :class="{'required': modal.isRequiredClassValidation('sex')}">{{
                                                        t('GENERAL.SEX')
                                                    }}: </label>
                                                <Select2 :settings="{ width: '100%', dropdownParent: '#customModalTwo'}"
                                                         id="sex"
                                                         name="sex" v-model="modal.client.sex" data-cy="client-sex"
                                                         placeholder="Selecione"
                                                         :options="modal.options"
                                                         @select="modal.inputSex(modal.client.sex), modal.isCompany = false"/>
                                                <div v-if="modal.invalid.sex" class="validation">{{
                                                        modal.invalid.sex
                                                    }}
                                                </div>
                                            </div>
                                        </div>
                                        <div v-if="modal.isPhisical" class="col-xl-2 col-lg-3 col-md-6 col-sm-6 col-12"
                                             id="marital_status_block">
                                            <div class="form-group">
                                                <label :class="{'required': modal.isRequiredClassValidation('marital_status_id')}"
                                                >{{ t('CLIENTS.MARITAL_STATUS') }}: </label>
                                                <Select2 v-if="modal.client?.marital_statuses?.name"
                                                         @select="modal.selectMaritalStatus($event)"
                                                         :options="[{id: 'selecione', text: 'selecione'}, ...modal.maritalStatusesOptions]"
                                                         id="marital_status_id" name="marital_status_id"
                                                         v-model="modal.client.marital_status_id"
                                                         :placeholder="modal.client?.marital_statuses?.name"
                                                         :settings="modal.maritalstatus"/>
                                                <Select2 v-else
                                                         @select="modal.selectMaritalStatus($event)"
                                                         :options="[{id: 'selecione', text: 'selecione'}, ...modal?.maritalStatusesOptions]"
                                                         id="marital_status_id" name="marital_status_id"
                                                         v-model="modal.client.marital_status_id"
                                                         placeholder="Selecione"
                                                         :settings="modal.maritalstatus"/>
                                                <div v-if="modal.invalid.marital_status_id" class="validation">{{
                                                        modal.invalid.marital_status_id
                                                    }}
                                                </div>
                                            </div>
                                        </div>
                                        <div v-if="modal.isPhisical" class="col-xl-3 col-lg-6 col-md-6 col-sm-6 col-12"
                                             id="spouse_block"><label>{{ t('CLIENTS.CONJUGE') }}: </label>
                                            <Select2 :settings="modal.settingSpouse"
                                                     @select="modal.selectSpouse"
                                                     :placeholder="modal.client.spouseName ? modal.client.spouseName : 'Selecione'"
                                                     id="spouse_id" name="spouse_id"
                                                     v-model="modal.client.spouse_id"
                                            ></Select2>
                                        </div>
                                        <div v-if="modal.isPhisical" class="col-xl-2 col-lg-3 col-md-6 col-sm-6 col-12">
                                            <label>{{ t('CLIENTS.WEDDING_DATE') }}: </label>
                                            <input type="date" class="form-control" id="wedding_date"
                                                   v-model="modal.client.wedding_date">
                                        </div>
                                        <div v-if="modal.isPhisical" class="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12">
                                            <label>{{ t('CLIENTS.MARRIAGE_CERTIFICATE_REGISTRATION') }}: </label>
                                            <input type="text" maxlength="32" class="form-control"
                                                   id="marriage_certificate_registration"
                                                   v-model="modal.client.marriage_certificate_registration">
                                        </div>
                                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12"
                                             v-if="!modal.isPhisical">
                                            <div class="form-group">
                                                <label :class="{'required': modal.isRequiredClassValidation('trade_name')}"
                                                       for="trade_name">{{ t('CLIENTS.TRADE_NAME') }}: </label>
                                                <input type="text" id="trade_name" name="trade_name"
                                                       v-model="modal.client.trade_name"
                                                       class="form-control">
                                                <div v-if="modal.invalid.trade_name" class="validation">{{
                                                        modal.invalid.trade_name
                                                    }}
                                                </div>
                                            </div>
                                        </div>
                                        <div v-if="modal.isPhisical" class="col-xl-2 col-lg-2 col-md-6 col-sm-6 col-6">
                                            <div class="form-group ">
                                                <label :class="{'required': modal.isRequiredClassValidation('rg')}"
                                                       for="rg">RG: </label>
                                                <input type="text" id="rg" name="rg" v-model="modal.client.rg"
                                                       class="form-control"
                                                       maxlength="15">
                                                <div v-if="modal.invalid.rg" class="validation">{{
                                                        modal.invalid.rg
                                                    }}
                                                </div>
                                            </div>
                                        </div>
                                        <div v-if="modal.isPhisical" class="col-xl-2 col-lg-6 col-md-6 col-sm-6 col-6">
                                            <div class="form-group">
                                                <label :class="{'required': modal.isRequiredClassValidation('dispatch_date')}"
                                                       for="dispatch_date">{{ t('CLIENTS.DISPATCH_DATE') }}: </label>
                                                <input type="text" id="dispatch_date" name="dispatch_date"
                                                       placeholder="dd-mm-aaaa"
                                                       v-mask="['##-##-####']"
                                                       v-model="modal.client.dispatch_date" class="form-control"
                                                       @change="modal.validateDate('dispatch_date')"
                                                >
                                                <div v-if="modal.invalid.dispatch_date" class="validation">{{
                                                        modal.invalid.dispatch_date
                                                    }}
                                                </div>
                                            </div>
                                        </div>
                                        <div v-if="modal.isPhisical" class="col-xl-2 col-lg-2 col-md-6 col-sm-6 col-6">
                                            <div class="form-group">
                                                <label :class="{'required': modal.isRequiredClassValidation('dispatching_agency')}"
                                                       for="dispatching_agency">{{
                                                        t('CLIENTS.DISPATCH_AGENCY')
                                                    }}: </label>
                                                <input type="text" id="dispatching_agency" name="dispatching_agency"
                                                       v-model="modal.client.dispatching_agency" class="form-control"
                                                       maxlength="15"
                                                >
                                                <div v-if="modal.invalid.dispatching_agency" class="validation">
                                                    {{ modal.invalid.dispatching_agency }}
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-xl-3 col-lg-6 col-md-6 col-sm-6 col-12" id="block_responsable">
                                            <div class="form-group">
                                                <label>{{ t('GENERAL.RESPONSABLE') }}: </label>
                                                <select2 :settings="modal.ajaxResponsable"
                                                         v-if="modal.client?.responsableName"
                                                         :placeholder="modal.client.responsableName"
                                                         @select="modal.selectedResponsableId"
                                                ></select2>
                                                <select2 v-else
                                                         :settings="modal.ajaxResponsable"
                                                         placeholder="Selecione"
                                                         @select="modal.selectedResponsableId">
                                                </select2>
                                            </div>
                                        </div>
                                        <div v-if="modal.isPhisical" class="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12"
                                             id="profession_block">
                                            <label :class="{'required': modal.isRequiredClassValidation('profession_id')}"
                                            >{{ t('CLIENTS.PROFESSION') }}: </label>
                                            <Select2 :settings="modal.setting"
                                                     @select="modal.inputProfession(modal.client.profession_id)"
                                                     v-if="modal.client?.profession_id && modal.client?.professions?.termo"
                                                     :placeholder="modal.client.professions.termo"
                                                     data-cy="client_add_profession"
                                                     id="profession_id"
                                                     name="profession"
                                                     v-model="modal.client.profession_id"
                                            ></Select2>
                                            <Select2 v-else
                                                     :settings="modal.setting"
                                                     @select="modal.inputProfession(modal.client.profession_id)"
                                                     data-cy="client_add_profession"
                                                     id="profession_id"
                                                     placeholder="Selecione"
                                                     name="profession"
                                                     v-model="modal.client.profession_id"
                                            ></Select2>
                                            <div v-if="modal.invalid.profession_id" class="validation">
                                                {{ modal.invalid.profession_id }}
                                            </div>
                                        </div>
                                        <div :class="modal.isPhisical ?'col-xl-3 col-lg-3 col-md-6 col-sm-6 col-6' : 'col-xl-4 col-lg-6 col-md-6 col-sm-6 col-6'">
                                            <div class="form-group " id="allotment_block">
                                                <label>Loteamento: </label>
                                                <select2 :settings="{width:'100%', dropdownParent: '#allotment_block'}"
                                                         :options="allotments"
                                                         placeholder="Selecione"
                                                         v-model="modal.client.allotment_id"
                                                ></select2>
                                            </div>
                                        </div>
                                        <div v-if="modal.isPhisical" class="col-xl-2 col-lg-3 col-md-6 col-sm-6 col-6">
                                            <div class="form-group ">
                                                <label :class="{'required': modal.isRequiredClassValidation('income')}"
                                                       for="income">Renda: </label>
                                                <input type="text"
                                                       id="income"
                                                       name="income"
                                                       v-money3="modal.valueConfig"
                                                       v-model.lazy="modal.client.income"
                                                       class="form-control"
                                                       maxlength="15">
                                                <div v-if="modal.invalid.income" class="validation">
                                                    {{ modal.invalid.income }}
                                                </div>
                                            </div>
                                        </div>
                                        <div v-if="modal.isPhisical" class="col-xl-2 col-lg-3 col-md-6 col-sm-6 col-6">
                                            <div class="form-group ">
                                                <label :class="{'required': modal.isRequiredClassValidation('income_family')}"
                                                       for="income_family">Renda Familiar: </label>
                                                <input type="text" id="income_family"
                                                       name="income_family"
                                                       v-money3="modal.valueConfig"
                                                       v-model.lazy="modal.client.income_family"
                                                       class="form-control"
                                                       maxlength="15">
                                                <div v-if="modal.invalid.income_family" class="validation">{{
                                                        modal.invalid.income_family
                                                    }}
                                                </div>
                                            </div>
                                        </div>
                                        <div v-if="modal.isPhisical" class="col-xl-2 col-lg-6 col-md-6 col-sm-6 col-6">
                                            <div class="form-group ">
                                                <label :class="{'required': modal.isRequiredClassValidation('work_on_company')}"
                                                       for="work_on_company">Empresa em que trabalha: </label>
                                                <input type="text"
                                                       id="work_on_company"
                                                       name="work_on_company"
                                                       v-model="modal.client.work_on_company"
                                                       class="form-control"
                                                       maxlength="128">
                                                <div v-if="modal.invalid.work_on_company" class="validation">{{
                                                        modal.invalid.work_on_company
                                                    }}
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-xl-3 col-lg-6 col-md-6 col-sm-6 col-12" id="block_broker"
                                             v-if="modal.isAdmin() && modal.client.id">
                                            <div class="form-group">
                                                <label>{{ t('CLIENTS.ADDED_BY') }}: </label>
                                                <Select2 :settings="{width: '100%', dropdownParent: '#block_broker'}"
                                                         :options="modal.realtors"
                                                         placeholder="Selecione"
                                                         v-model="modal.client.created_by"
                                                ></Select2>
                                            </div>
                                        </div>
                                        <div :class="modal.isPhisical ? 'col-xl-3 col-lg-6 col-md-6 col-sm-6 col-12' : 'col-xl-5 col-lg-6 col-md-12 col-sm-12 col-12'">
                                            <div class="form-group">
                                                <label :class="{'required': modal.isRequiredClassValidation('email')}"
                                                       for="email">{{ t('GENERAL.EMAIL') }}: </label>
                                                <input data-cy="client_add_email" type="text" id="email" name="email"
                                                       v-model="modal.client.email"
                                                       class="form-control"
                                                       placeholder="exemplo@exem.com">
                                                <div v-if="modal.invalid.email" class="validation">
                                                    {{ modal.invalid.email }}
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-xl-2 col-lg-3 col-md-6 col-sm-6 col-6" v-if="modal.isPhisical">
                                            <div class="form-group">
                                                <label :class="{'required': modal.isRequiredClassValidation('nationality')}"
                                                       for="nationality">{{ t('CLIENTS.NATIONALITY') }}: </label>
                                                <input type="text" id="nationality" name="nationalitynationality"
                                                       v-model="modal.client.nationality"
                                                       class="form-control">
                                                <div v-if="modal.invalid.nationality" class="validation">
                                                    {{ modal.invalid.nationality }}
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-xl-2 col-lg-3 col-md-6 col-sm-6 col-6" v-if="modal.isPhisical">
                                            <div class="form-group">
                                                <label :class="{'required': modal.isRequiredClassValidation('naturalness')}"
                                                       for="naturalness">{{ t('CLIENTS.BIRTH_PLACE') }}: </label>
                                                <input type="text" id="naturalness" name="naturalness"
                                                       v-model="modal.client.naturalness"
                                                       class="form-control">
                                                <div v-if="modal.invalid.naturalness" class="validation">
                                                    {{ modal.invalid.naturalness }}
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-xl-3 col-lg-12 col-md-12 col-sm-12 col-12"
                                             v-if="modal.isPhisical">
                                            <div class="form-group">
                                                <label :class="{'required': modal.isRequiredClassValidation('mother_name')}"
                                                       for="mother_name">{{ t('CLIENTS.MOTHER_NAME') }}: </label>
                                                <input type="text" id="mother_name" name="mother_name"
                                                       v-model="modal.client.mother_name"
                                                       class="form-control">
                                                <div v-if="modal.invalid.mother_name" class="validation">
                                                    {{ modal.invalid.mother_name }}
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-xl-2 col-lg-12 col-md-12 col-sm-12 col-12"
                                             v-if="modal.isPhisical">
                                            <div class="form-group">
                                                <label for="father_name"
                                                       :class="{'required': modal.isRequiredClassValidation('father_name')}"
                                                >{{ t('CLIENTS.FATHER_NAME') }}: </label>
                                                <input type="text" id="father_name" name="father_name"
                                                       v-model="modal.client.father_name"
                                                       class="form-control">
                                                <div v-if="modal.invalid.father_name" class="validation">
                                                    {{ modal.invalid.father_name }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </SectionCardComponent>
                            </div>
                        </div>
                        <div class="row gutters">
                            <div class="col-xl-12 col-lglg-12 col-md-12 col-sm-12 col-12">
                                <phoneComponentInline :required="modal.isRequiredClassValidation('phones')"
                                                      :phonesIndex="modal.client.phones"
                                                      :isInvalid="modal.invalid.phones"
                                                      :clear-data-phone="modal.clearDataPhone"
                                                      @alterDescription="modal.alterDescription"
                                                      @alterType="modal.alterType"
                                                      @alterNumber="modal.alterNumber"
                                                      @cleaned="modal.cleanedPhone"
                                                      @update="modal.updatePhone($event)"
                                                      @create="modal.createPhone($event)"
                                ></phoneComponentInline>
                                <div v-if="modal.invalid.phones" class="validation">{{ modal.invalid.phones }}</div>
                            </div>
                        </div>
                        <div class="row gutters">
                            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 mt-3">
                                <div class="form-group">
                                    <label for="signature"
                                           :class="{'required': modal.isRequiredClassValidation('description')}"
                                    >Observação: </label>
                                    <editor :init="modal.configTinyMce" v-model="modal.client.description"
                                            id="description"
                                            @update:modelValue="modal.summernoteChange($event)"
                                            tinymce-script-src="https://tiny.r2app.com.br/js/tinymce/tinymce.min.js"
                                    >
                                    </editor>
                                    <div v-if="modal.invalid.description" class="validation">
                                        {{ modal.invalid.description }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="tab-pane fade" :class="{ active: modal.activeTab == 1, show: modal.activeTab == 1 }"
                     id="localization"
                     role="tabpanel" aria-labelledby="localization-tab">
                    <div class="modal-body pl-0 pr-0">
                        <SectionCardComponent
                                eyebrow="Endereço"
                                title="Localização principal do cliente"
                                subtitle="Informe CEP, logradouro, numero, bairro, cidade e complementos quando necessário."
                                icon="icon-location">
                            <address-generic v-if="modal.address"
                                             :is-invalid="modal.invalid.address"
                                             :is-cep-required="modal.isRequiredClassValidation('address_id')"
                                             :addressIndex="modal.address"
                                             @update="modal.updateAddress($event)"
                            />
                        </SectionCardComponent>
                    </div>
                </div>
                <div class="tab-pane fade" :class="{ active: modal.activeTab === 2, show: modal.activeTab === 2 }"
                     id="comercialAddress" v-if="modal.isPhisical"
                     role="tabpanel" aria-labelledby="comercialaddress-tab">
                    <div class="modal-body pl-0 pr-0">
                        <SectionCardComponent
                                eyebrow="Endereço comercial"
                                title="Local de trabalho ou referencia profissional"
                                subtitle="Informe os dados de endereço comercial quando forem necessários para o cadastro."
                                icon="icon-location">
                            <address-generic v-if="modal.activeTab == 2"
                                             :is-invalid="modal.invalid.addressComercial"
                                             :addressIndex="modal.comercialAddress"
                                             :is-cep-required="modal.isRequiredClassValidation('comercial_address_id')"
                                             @update="modal.updateComerciaAddress($event)"
                            />
                        </SectionCardComponent>
                    </div>
                </div>
                <div class="tab-pane fade" :class="{ active: modal.activeTab == 3, show: modal.activeTab == 3 }"
                     id="document"
                     role="tabpanel" aria-labelledby="document-tab">
                    <div class="modal-body pl-0 pr-0">
                        <SectionCardComponent
                                eyebrow="Anexos"
                                title="Envie os documentos do cliente"
                                icon="icon-file_upload">
                            <template #subtitle>
                                Tipos obrigatórios aparecem destacados com <span
                                    class="client-anex-panel__required-mark">*</span>. Formatos aceitos: .pdf, .png,
                                .jpg e .jpeg ate 9MB.
                            </template>
                            <template #actions>
                                <span class="client-anex-panel__counter">
                                    {{
                                        modal.client?.documents?.length || 0
                                    }} {{ modal.client?.documents?.length === 1 ? 'arquivo' : 'arquivos' }}
                                </span>
                            </template>

                            <div class="client-anex-summary" v-if="modal.requiredDriveTypes.length">
                                <div class="client-anex-summary__item">
                                    <strong>{{ modal.requiredDriveTypes.length }}</strong>
                                    <small>{{
                                            modal.requiredDriveTypes.length === 1 ? 'tipo obrigatório' : 'tipos obrigatórios'
                                        }}</small>
                                </div>
                                <div class="client-anex-summary__item">
                                    <strong>{{
                                            modal.requiredDriveTypes.filter(type => modal.hasDocumentByDriveType(type.id)).length
                                        }}</strong>
                                    <small>obrigatório enviados</small>
                                </div>
                            </div>

                            <div class="client-anex-section" v-if="modal.requiredDriveTypes.length">
                                <div class="client-anex-section__title">Obrigatórios</div>
                                <div class="client-anex-type-grid">
                                    <div class="client-anex-type-card client-anex-type-card--required"
                                         v-for="type in modal.requiredDriveTypes" :key="`required-${type.id}`">
                                        <div class="client-anex-type-card__content">
                                            <span class="client-anex-type-card__icon"><i
                                                    class="icon-file_upload"></i></span>
                                            <div>
                                                <strong class="required">{{ type.text }}</strong>
                                                <small>{{
                                                        modal.hasDocumentByDriveType(type.id) ? 'Arquivo enviado para este tipo.' : 'Obrigatório para concluir o cadastro.'
                                                    }}</small>
                                            </div>
                                        </div>
                                        <button type="button" class="btn btn-primary btn-sm"
                                                @click.prevent.stop="modal.selectDriveTypeAndUpload(type.id)">
                                            {{ modal.hasDocumentByDriveType(type.id) ? 'Adicionar outro' : 'Anexar' }}
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <div class="client-anex-section" v-if="modal.optionalDriveTypes.length">
                                <div class="client-anex-section__title">Opcionais</div>
                                <div class="client-anex-type-grid">
                                    <div class="client-anex-type-card" v-for="type in modal.optionalDriveTypes"
                                         :key="`optional-${type.id}`">
                                        <div class="client-anex-type-card__content">
                                            <span class="client-anex-type-card__icon"><i
                                                    class="icon-file_upload"></i></span>
                                            <div>
                                                <strong>{{ type.text }}</strong>
                                                <small>{{
                                                        modal.hasDocumentByDriveType(type.id) ? 'Arquivo enviado para este tipo.' : 'Envie se for necessário.'
                                                    }}</small>
                                            </div>
                                        </div>
                                        <button type="button" class="btn btn-outline-primary btn-sm"
                                                @click.prevent.stop="modal.selectDriveTypeAndUpload(type.id)">
                                            {{ modal.hasDocumentByDriveType(type.id) ? 'Adicionar outro' : 'Anexar' }}
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <div class="client-anex-files pb-3">
                                <div class="client-anex-files__title">Arquivos enviados</div>
                                <div class="client-anex-file-card" v-for="(document, key) in modal.client.documents"
                                     :key="key">
                                    <div class="client-anex-file-card__icon"><i class="icon-file"></i></div>
                                    <div class="client-anex-file-card__info">
                                        <strong>{{ document.name }}</strong>
                                        <small>{{ modal.getDriveTypeText(document.drive_files_type_id) }} ·
                                            {{ modal.formatSize(document.file_size) }}</small>
                                    </div>
                                    <div class="client-anex-file-card__actions">
                                        <button type="button" class="btn btn-outline-primary btn-sm" v-if="document.id"
                                                @click="modal.downloadDocument(document)">
                                            <i class="icon-download"></i>
                                        </button>
                                        <button type="button" class="btn btn-outline-danger btn-sm"
                                                @click="modal.documentDelete(document, key)">
                                            <i class="icon-trash-2"></i>
                                        </button>
                                    </div>
                                </div>
                                <div class="client-anex-empty" v-if="!modal.client?.documents?.length">
                                    Nenhum anexo foi cadastrado. Escolha um tipo acima para enviar o primeiro arquivo.
                                </div>
                            </div>
                        </SectionCardComponent>
                    </div>
                </div>
            </div>
            <div class="modal-footer" style="justify-content: space-between">
                <div>
                    <h5 class="ml-3" style="color: red; font-size: .7rem;">{{ t('GENERAL.REQUIRED_FIELDS') }} *</h5>
                </div>
                <div>
                    <button class="btn btn-secondary mr-2" type="button" v-if="modal.activeTab != 0"
                            @click="modal.backActiveTab">{{ t('ALLOTMENT.PREVIOUS') }}
                    </button>
                    <button data-cy="client_add_next" class="btn btn-secondary mr-2" type="button"
                            v-if="modal.activeTab !== 3"
                            @click="modal.next()">{{ t('ALLOTMENT.NEXT') }}
                    </button>
                    <button data-cy="client_add_save" class="btn btn-primary" type="submit">
                        {{ t('ACTIONS.SAVE') }}
                    </button>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import {useToast} from 'vue-toastification';
import {useI18n} from 'vue-i18n';
import Select2 from 'vue3-select2-component';
import Editor from '@tinymce/tinymce-vue';
import phoneComponentInline from '../../../components/layouts/phoneComponentInline';
import addressGeneric from '@/components/layouts/addressComponent.vue';
import SectionCardComponent from '@/components/layouts/SectionCardComponent.vue';
import {Money3Directive} from 'v-money3';
import {mapState} from 'vuex';

export default {
    name: "contentCreatePersonModalDesktop",
    setup() {
        const toast = useToast();
        const {t} = useI18n();
        return {t, toast}
    },
    directives: {money3: Money3Directive},
    props: ['modalIndex'],
    components: {
        Select2,
        addressGeneric,
        Editor,
        phoneComponentInline,
        SectionCardComponent,
    },
    computed: {
        ...mapState({allotments: 'allotmentsOnlyUserAllo'})
    },
    watch: {
        modalIndex() {
            this.modal = this.modalIndex;
        }
    },
    mounted() {
        this.modal = this.modalIndex;
    },
    data() {
        return {
            modal: null,
        }
    }
}
</script>

<style scoped>
.client-main-panel__required-mark {
    color: #dc3545;
    font-weight: 700;
}

.client-anex-panel__required-mark {
    color: #dc3545;
    font-weight: 700;
}

.client-anex-panel__counter,
.client-anex-summary__item {
    background: #e7f4f0;
    border-radius: 999px;
    color: #0e5e4e;
    font-size: 12px;
    font-weight: 700;
    padding: 8px 12px;
    white-space: nowrap;
}

.client-anex-summary {
    display: flex;
    gap: 10px;
    margin-bottom: 16px;
}

.client-anex-summary__item {
    align-items: center;
    border-radius: 12px;
    display: flex;
    gap: 8px;
}

.client-anex-section {
    margin-top: 16px;
}

.client-anex-section__title,
.client-anex-files__title {
    color: #173b34;
    font-size: 13px;
    font-weight: 700;
    margin-bottom: 10px;
}

.client-anex-type-grid,
.client-anex-files {
    display: grid;
    gap: 10px;
}

.client-anex-type-card,
.client-anex-file-card,
.client-anex-empty {
    background: #ffffff;
    border: 1px solid #e3eeeb;
    border-radius: 12px;
    padding: 12px;
}

.client-anex-type-card,
.client-anex-file-card {
    align-items: center;
    display: flex;
    gap: 12px;
    justify-content: space-between;
}

.client-anex-type-card--required {
    border-color: rgba(220, 53, 69, .28);
}

.client-anex-type-card__content,
.client-anex-file-card__info {
    align-items: center;
    display: flex;
    gap: 12px;
    min-width: 0;
}

.client-anex-type-card__icon,
.client-anex-file-card__icon {
    align-items: center;
    background: #0e5e4e;
    border-radius: 12px;
    color: #ffffff;
    display: flex;
    flex: 0 0 42px;
    height: 42px;
    justify-content: center;
}

.client-anex-type-card strong,
.client-anex-file-card strong {
    color: #173b34;
    display: block;
}

.client-anex-file-card__info {
    align-items: flex-start;
    flex: 1;
    flex-direction: column;
    gap: 2px;
}

.client-anex-file-card__info strong,
.client-anex-file-card__info small {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 100%;
}

.client-anex-file-card__actions {
    display: flex;
    gap: 8px;
}

.client-anex-files {
    margin-top: 18px;
}

.client-anex-empty {
    background: rgba(14, 94, 78, 0.06);
    border-style: dashed;
    color: #52716a;
    font-size: 13px;
}

.responsible-panel__search,
.responsible-panel__item {
    align-items: center;
    display: flex;
    gap: 14px;
    justify-content: space-between;
}

.responsible-panel__counter {
    background: #e7f4f0;
    border-radius: 999px;
    color: #0e5e4e;
    font-size: 12px;
    font-weight: 700;
    padding: 8px 12px;
    white-space: nowrap;
}

.responsible-panel__search {
    margin: 16px 0 10px;
}

.responsible-panel__input {
    flex: 1;
    position: relative;
}

.responsible-panel__input i {
    color: #0e5e4e;
    left: 13px;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
}

.responsible-panel__input .form-control {
    border-radius: 10px;
    height: 42px;
    padding-left: 38px;
}

.responsible-panel__list {
    display: grid;
    gap: 10px;
    margin-top: 12px;
}

.responsible-panel__item {
    background: #ffffff;
    border: 1px solid #e3eeeb;
    border-radius: 12px;
    padding: 12px;
}

.responsible-panel__avatar {
    align-items: center;
    background: #0e5e4e;
    border-radius: 12px;
    color: #ffffff;
    display: flex;
    flex: 0 0 42px;
    font-weight: 700;
    height: 42px;
    justify-content: center;
    text-transform: uppercase;
}

.responsible-panel__info {
    display: flex;
    flex: 1;
    flex-direction: column;
    min-width: 0;
}

.responsible-panel__info strong,
.responsible-panel__info small {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.responsible-panel__empty {
    background: rgba(14, 94, 78, 0.06);
    border: 1px dashed #b9d8d0;
    border-radius: 12px;
    color: #52716a;
    font-size: 13px;
    padding: 12px;
}

:global(html.dark-theme .responsible-panel__info strong ) {
    color: var(--dark-text) !important;
}

:global(html.dark-theme .responsible-panel__input i ) {
    color: var(--dark-primary) !important;
}

:global(html.dark-theme .responsible-panel__info small ) {
    color: var(--dark-text-muted) !important;
}

:global(html.dark-theme .responsible-panel__counter ) {
    background: var(--dark-primary-soft) !important;
    color: var(--dark-text) !important;
}

:global(html.dark-theme .responsible-panel__item ) {
    background: var(--dark-surface-2) !important;
    border-color: var(--dark-border) !important;
}

:global(html.dark-theme .responsible-panel__empty ) {
    background: var(--dark-primary-soft) !important;
    border-color: var(--dark-border-strong) !important;
    color: var(--dark-text-soft) !important;
}

:global(html.dark-theme .responsible-panel__avatar ) {
    background: var(--dark-surface-3) !important;
    color: var(--dark-primary) !important;
}

:global(html.dark-theme .client-anex-section__title),
:global(html.dark-theme .client-anex-files__title),
:global(html.dark-theme .client-anex-type-card strong),
:global(html.dark-theme .client-anex-file-card strong ) {
    color: var(--dark-text) !important;
}

:global(html.dark-theme .client-anex-type-card small),
:global(html.dark-theme .client-anex-file-card small ) {
    color: var(--dark-text-muted) !important;
}

:global(html.dark-theme .client-anex-panel__counter),
:global(html.dark-theme .client-anex-summary__item ) {
    background: var(--dark-primary-soft) !important;
    color: var(--dark-text) !important;
}

:global(html.dark-theme .client-anex-type-card),
:global(html.dark-theme .client-anex-file-card ) {
    background: var(--dark-surface-2) !important;
    border-color: var(--dark-border) !important;
}

:global(html.dark-theme .client-anex-empty ) {
    background: var(--dark-primary-soft) !important;
    border-color: var(--dark-border-strong) !important;
    color: var(--dark-text-soft) !important;
}

:global(html.dark-theme .client-anex-type-card__icon),
:global(html.dark-theme .client-anex-file-card__icon ) {
    background: var(--dark-surface-3) !important;
    color: var(--dark-primary) !important;
}

</style>
